import { render, staticRenderFns } from "./myShopOrderReturn.vue?vue&type=template&id=1ae9e132&scoped=true"
import script from "./myShopOrderReturn.vue?vue&type=script&lang=js"
export * from "./myShopOrderReturn.vue?vue&type=script&lang=js"
import style0 from "./myShopOrderReturn.vue?vue&type=style&index=0&id=1ae9e132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae9e132",
  null
  
)

export default component.exports